export const marcaBlancaApi = {
  getAppInitialDataBySeccions: (appId) => `/empresa-secciones?empresaId=${appId}&inicial=true`,
  getTemplateData: (appId) => `/empresa-template?empresaId=${appId}`,
  getBannersBySections: () => `/empresa-banner?typeRequest=GET_BANNERS`,
  getBannerById: (bannerId) => `/empresa-banner/${bannerId}`,
  // getBannersBySections: '/EmpresaBanner/banners/?empresaId=0&seccionId=0&esDefault=0',
  getCustomSectionById: (sectionId) => `/secciones-custom/${sectionId}`,
  getDefaultSectionById: (sectionId) => `/secciones-default/${sectionId}`,
};

export const geo = {
  getCities: '/provincia',
  getLocalities: '/localidad',
};

export const packageSuppliersApi = {
  getPackageById: (packageId) => `/package/${packageId}`,
  getPackageByIdAndHotelInformationId: (packageId, hotelInformationId) =>
    `/package/${packageId}/hotel/${hotelInformationId}`,
  getPackageConfigurationById: (packageConfigurationId) =>
    `/package-configuration/${packageConfigurationId}`,
  getDeparturesByPackageId: (packageId) => `/package/${packageId}/departures`,
  getConfigurationsByPackageId: (packageId) => `/package/${packageId}/configurations`,
};

/* 
GET /api/package/:id/configurations

Params:
id: string - El external_id del package a buscar

Query:
departureDate: string (formato YYYY-MM-DD) - La fecha de salida
occupation: number - Cantidad de pasajeros

Returns
{
  flight: informacion del vuelo
  hotelInformationList: informacion de los hoteles con sus precios - hotelInformation & totalManager
}
------------------------------------------------
GET /api/package/:id/departures

Params:
id: string - El external_id del package a buscar

Query:
from: string (formato YYYY-MM-DD) - La fecha desde
to: string (formato YYYY-MM-DD) - La fecha hasta

Returns
string[] <- Retorna las fechas simplemente como un array de string

 */
